module.exports = __webpack_public_path__ + "static/media/icon-th-list.3cca9211.svg";